import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;

  grid-template-columns: repeat(auto-fill, minmax(min(428px, 100%), 1fr));
  gap: 32px 24px;
`;
